import { getAllEssenceTypes, type EssencePool } from '@sorrem/shared';
import { EssenceVesselEntry } from './components/EssenceVesselEntry';
import styles from './EssenceVessel.module.scss';

interface EssenceVesselProps {
    /** The essence to show: banked outside a run, carried or banked in one. */
    essence: EssencePool;
    /** The list's accessible name, saying which essence it shows. */
    label?: string;
}

/** Essence by type in a 3x2 grid of entries. */
export function EssenceVessel({ essence, label = 'Essence vessel' }: EssenceVesselProps): JSX.Element {
    return (
        <ul className={styles.essenceVessel} aria-label={label}>
            {getAllEssenceTypes().map((type) => (
                <EssenceVesselEntry key={type} type={type} value={essence[type]} />
            ))}
        </ul>
    );
}
